import React from "react";
import { Hotel } from "./api/hotel";

interface HotelCardProps {
  hotel: Hotel;
  onInquiry: (hotelName: string) => void;
}

const HotelCard: React.FC<HotelCardProps> = ({ hotel, onInquiry }) => {
  return (
    <div
      style={{
        width: "320px",
        borderRadius: "16px",
        overflow: "hidden",
        background: "#fff",
        boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
        display: "flex",
        flexDirection: "column",
        transition: "transform 0.2s ease-in-out",
      }}
      onMouseEnter={(e) =>
        ((e.currentTarget as HTMLElement).style.transform = "scale(1.03)")
      }
      onMouseLeave={(e) =>
        ((e.currentTarget as HTMLElement).style.transform = "scale(1)")
      }
    >
      {/* Image */}
      <div style={{ height: "200px", overflow: "hidden" }}>
        <img
          src={hotel.image}
          alt={hotel.name}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </div>

      {/* Content */}
      <div style={{ padding: "1rem", flex: "1" }}>
        <h3 style={{ margin: "0 0 0.5rem 0", fontSize: "1.25rem", color: "#333" }}>
          {hotel.name}
        </h3>

        {hotel.facilities && (
          <p style={{ fontSize: "0.9rem", color: "#555", margin: "0 0 0.5rem" }}>
            {hotel.facilities}
          </p>
        )}

        {hotel.description && (
          <p
            style={{
              fontSize: "0.85rem",
              color: "#666",
              margin: "0 0 0.75rem",
              lineHeight: "1.4",
            }}
          >
            {hotel.description.length > 120
              ? hotel.description.substring(0, 120) + "..."
              : hotel.description}
          </p>
        )}

        <p
          style={{
            fontWeight: "bold",
            fontSize: "1rem",
            color: "#0077b6",
            margin: "0 0 0.5rem",
          }}
        >
          {hotel.price}
        </p>

        <p style={{ fontSize: "0.85rem", color: "#777" }}>{hotel.location}</p>
      </div>

      {/* Inquiry Button */}
      <div style={{ padding: "1rem", borderTop: "1px solid #eee", textAlign: "center" }}>
        <button
          onClick={() => onInquiry(hotel.name)}
          style={{
            padding: "0.6rem 1.2rem",
            background: "#0077b6",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "0.9rem",
            transition: "background 0.2s ease-in-out",
          }}
          onMouseOver={(e) =>
            ((e.currentTarget as HTMLButtonElement).style.background = "#005f87")
          }
          onMouseOut={(e) =>
            ((e.currentTarget as HTMLButtonElement).style.background = "#0077b6")
          }
        >
          Inquire
        </button>
      </div>
    </div>
  );
};

export default HotelCard;
